import { createRoute, useNavigate } from "@tanstack/react-router";
import { ReviewDesk, ReviewScriptDetail } from "@/features/review";
import { rootRoute } from "./root";

export const reviewScriptDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/review/$scriptId",
  component: function ReviewDetail() {
    const { scriptId } = reviewScriptDetailRoute.useParams();
    const navigate = useNavigate();
    return (
      <ReviewDesk>
        <ReviewScriptDetail scriptId={scriptId} onBack={() => navigate({ to: "/review" })} />
      </ReviewDesk>
    );
  },
});
